// React
import { memo } from "react";

// UI
import { TableSearch } from "ui/components/Table/TableSearch";

// Tipovi i konstante
import { PRICING_SEARCH_COLUMNS } from "./consts";
import { PricingSearchResultsProps } from "./types";

/**
 * Popis verzija cjenika. Klik na redak otvara tu verziju.
 *
 * Verzije se ne brišu kad ih zamijeni novija — na njih se vežu izdani računi, pa popis
 * namjerno prikazuje i zamrznute.
 */
const PricingSearchResults: React.FC<PricingSearchResultsProps> = (
  props: PricingSearchResultsProps
) => {
  const { versions, onSelect } = props;

  return (
    <TableSearch
      columns={PRICING_SEARCH_COLUMNS}
      data={versions}
      selectableRows={false}
      onRowClick={onSelect}
      disablePagination
    />
  );
};

export default memo(PricingSearchResults);
